import { BREAKPOINTS } from '@libs/common-next';

import { PICTURES } from '../../constants';

export const IMAGE_SIZES = {
    SizeSm: 250,
    SizeMd: 350,
    SizeLg: 400,
} as const;

const createPictureItem = (size: number, breakpoint: number) => ({
    srcSet: `${PICTURES.NOT_FOUND.SRC}?fmt=webp&wid=${size}&hei=${size} 1x, ${PICTURES.NOT_FOUND.SRC}?fmt=webp&wid=${size * 2}&hei=${size * 2} 2x`,
    media: `(min-width: ${breakpoint}px)`,
});

export const pictureItems = [
    createPictureItem(IMAGE_SIZES.SizeLg, BREAKPOINTS.lg),
    createPictureItem(IMAGE_SIZES.SizeMd, BREAKPOINTS.md),
    createPictureItem(IMAGE_SIZES.SizeSm, BREAKPOINTS.sm2),
];
